export default __webpack_public_path__ + "static/media/68.45dbc7df.jpg";